import React from 'react';
import { css } from 'aphrodite';
import styles from '../button-styles';
import '../button-loading-styles.css';
import rbStyles from './red-button-styles';
import { withRouter } from 'react-router-dom';
import buttonClick from '../button-click';

const RedButton = (props) => (
  <div className={css(styles.root, rbStyles.root, props.loading && styles.rootLoading, props.disabled && styles.rootDisabled)} onClick={buttonClick(props)}>
    <div className={css(styles.title, rbStyles.title, props.loading && styles.titleLoading)}>{props.title}</div>
    {props.loading && <div className={'loading'} style={{ position: 'absolute', top: 3, texAlign: 'center' }}>
      <span>.</span><span>.</span><span>.</span>
    </div>}
  </div>
);

export default withRouter(RedButton);



// WEBPACK FOOTER //
// ./src/components/common/button/red-button/red-button.js